<template>
    <div class="sms-input">
        <div class="phone-input">
            <vue-country-code
                class="col-3 country-code"
                :enabledCountryCode="true"
                @onSelect="onSelect($event)"
                defaultCountry="TR"
            />
            <a-input
                v-model="cloneValue.number"
                :placeholder="$t('message.phone')"
                autocomplete="off"
                trim
                type="text"
                v-mask="'############'"
            />
        </div>
        <a-select v-model="cloneValue.senderId">
            <template #suffixIcon>
                <div class="material-icons">add_to_home_screen</div>
            </template>
            <a-select-option :selected="true" value="PSTCELLTEST">PSTCELLTEST</a-select-option>
        </a-select>
        <a-select v-model="cloneValue.channelId">
            <template #suffixIcon>
                <div class="material-icons">settings_cell</div>
            </template>
            <a-select-option :key="channel._id" v-for="channel of smsChannels" :value="channel._id">
                {{ channel.name }}
            </a-select-option>
        </a-select>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { log2 } from "../../../../../utils/log2";
import VueCountryCode from "vue-country-code";

const log = log2("SMSInput");
export default {
    name: "SMSInput",
    components: { VueCountryCode },
    props: {
        value: {
            type: Object,
            default: () => ({
                channelId: null,
                senderId: null,
                number: null,
            }),
        },
    },
    data: () => ({
        cloneValue: {
            channelId: null,
            senderId: null,
            countryCode: "90",
            number: null,
        },
    }),
    computed: {
        ...mapState({
            smsChannels: (state) => state.channel.channels.filter((x) => x.type === "sms-postacell"),
        }),
    },
    methods: {
        ...mapActions({
            listChannels: "channel/listChannels",
        }),
        onSelect(e) {
            this.cloneValue.countryCode = e.dialCode;
        },
    },
    mounted() {
        this.cloneValue = this.$_.cloneDeep(this.value);
        this.cloneValue.senderId = "PSTCELLTEST";
        this.listChannels();
    },
    watch: {
        value: {
            handler() {
                if (this.$_.isEqual(this.cloneValue, this.value)) return;
                this.cloneValue = this.$_.cloneDeep(this.value);
            },
            deep: true,
        },
        cloneValue: {
            handler() {
                this.$emit("input", {
                    ...this.cloneValue,
                    countryCode: this.countryCode,
                    number: this.cloneValue.number || "",
                });
            },
            deep: true,
        },
        smsChannels: {
            handler: function (val) {
                if (val.length > 0) {
                    this.cloneValue.channelId = val[0]._id;
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss">
.sms-input {
    width: 100%;
    background: #fafbfd;
    border-bottom: 1px solid var(--border-neutral-default);
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;

    .ant-select {
        width: 100%;

        .material-icons {
            font-size: 18px;
        }
    }

    .phone-input {
        display: flex;
        width: 100%;
        align-items: center;

        .vue-country-select {
            border: none !important;
            padding-left: 0 !important;
            padding-right: 0 !important;
            box-shadow: none !important;

            .dropdown {
                background: none !important;

                &-list {
                    bottom: 100% !important;
                    top: auto !important;
                }
            }
        }
    }
}
</style>
